export class MapAssetRepresentation {
  icon: string;
  id: number;
  name: string;
  targetColor?: string
  status?: string;

  constructor(icon: string, id: number, name: string, targetColor?: string, status?: string ) {
    this.icon = icon;
    this.id = id;
    this.name = name;
    this.targetColor = targetColor;
    this.status = status;
  }

  getIdentifier(){
    const idWithStatus = `${this.id}-${this.status}`
    return `${ this.status ?  idWithStatus : this.id }`;
  }

  public static cloneWithStatus(mapAssetRepresentation: MapAssetRepresentation, status:string){
    return new MapAssetRepresentation(mapAssetRepresentation.icon, mapAssetRepresentation.id, mapAssetRepresentation.name, mapAssetRepresentation.targetColor, status);
  }
}
